import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { ProfileLobby } from "./ProfileLobby";
import { Routes, RouterModule } from "@angular/router";
import { OptionsHttp } from "providers/http/OptionsHttp";
import { LoginHttp } from "providers/http/LoginHttp";
import { MainHttp } from "providers/http/MainHttp";
import { App } from "components/app/App";
import { ProfileHttp } from "providers/http/ProfileHttp";
import { AplicationsModule } from "components/app/aplications/aplications.module";
import { ImageErrorModule } from "directives/ImageError";
import { ProfilePruebaModule } from "components/myProfile/MyProfile";

@NgModule({
    declarations: [
        ProfileLobby
    ],
    imports: [
        FormsModule,
        CommonModule,
        ImageErrorModule,
        RouterModule,
        AplicationsModule,
        ProfilePruebaModule
    ],
    providers: [
        OptionsHttp,
        LoginHttp,
        MainHttp,
        ProfileHttp,
        App
    ],
    entryComponents: [],
    exports: [ProfileLobby]
})
export class ProfileLobbyModule {
}